import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {client} from "../../services/api-client";
import {AxiosError} from "axios";
import {IContact, ISocialMedia} from "../../types/generalTypes";
import {toast} from "react-toastify";


export interface IUpdateUserPayload {
    payload: {
        id: number,
        // name: string,
        socialMedia: ISocialMedia,
        contact: IContact
    },
    closeForm: () => void
}

export interface IUser {
    id: number,
    name: string,
    socialMedia: null | ISocialMedia,
    contact: null | IContact
}


interface IGetIClientsResp {
    totalItems: number,
    pageNum: number,
    pageSize: number,
    message: string,
    isOK: boolean,
    sort: null | string,
    sortField: null | string,
    search: null | string,
    items: IUser[]
}

interface IUserssState {
    users: IUser[],
    totalCount: number,
    pageNumber: number,
    itemsPerPage: number,
    pageSize: number
}

const initialState: IUserssState = {
    users: [],
    totalCount: 0,
    pageNumber: 1,
    itemsPerPage: 25,
    pageSize: 0
};


export const getUsers = createAsyncThunk<IGetIClientsResp, string, { rejectValue: string }>(
    'users/get-users',
    async (queryParams, {rejectWithValue}) => {
        try {
            const {data} = await client.get(`api/crm/users${queryParams}`);
            return data
        } catch (e) {
            if (e instanceof AxiosError) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)

export const updateUser = createAsyncThunk<IUser, IUpdateUserPayload, { rejectValue: string }>(
    'users/update-user',
    async (body, {rejectWithValue}) => {
        try {
            const {data} = await client.put(`api/crm/users`, body.payload);
            toast.info("SDC: User has been updated")
            body.closeForm();
            return data
        } catch (e) {
            if (e instanceof AxiosError) {
                return rejectWithValue(e.response?.data)
            }
        }
    }
)


const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setPageNumber: (state, action: PayloadAction<number>) => {
            state.pageNumber = action.payload;
        },
        setItemsPerPage: (state, action: PayloadAction<number>) => {
            state.itemsPerPage = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsers.fulfilled, (state, {payload}) => {
                state.users = payload.items;
                state.pageNumber = payload.pageNum;
                state.totalCount = payload.totalItems;
                state.pageSize = payload.pageSize
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                state.users = state.users.map(user => user.id === action.payload.id ? action.payload : user)
            })
    }
});

export const {setPageNumber, setItemsPerPage} = usersSlice.actions;
export default usersSlice.reducer;
